import OnvoBase from "@/base";
import { IntegrationTable } from "../types/index.js";

export class OnvoIntegrationTables extends OnvoBase {
    #integrationId: string;

    constructor(
        integrationId: string,
        apiKey: string,
        options?: { endpoint: string }
    ) {
        super(apiKey, options);
        this.#integrationId = integrationId;
    }

    list(): Promise<IntegrationTable[]> {
        return this._fetchBase("/api/integration-tables?integration=" + this.#integrationId) as Promise<IntegrationTable[]>;
    }
    update(id: string, body: Partial<IntegrationTable>): Promise<IntegrationTable> {
        return this._fetchBase("/api/integration-tables/" + id, "PUT", body) as Promise<IntegrationTable>;
    }
}